module.exports = __webpack_public_path__ + "img/text-share-link-1.00208e9a.png";